import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  CreateNewMapContainer, type CreateNewMapContainerProps,
} from './createNewMap.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    CreateNewMap: CreateNewMapContainerProps;
  }
}
modalRenderer.register('CreateNewMap', CreateNewMapContainer);
